import styled from 'styled-components';

export const LabelText = styled.p`
  font-weight: bold;
  margin-bottom: 0;
  text-align: right;
  width: 100%;
`;

export const ValueText = styled.p`
  margin-bottom: 0;
  width: 100%;
`;

export const SuccessText = styled.p`
  font-weight: bold;
  margin-bottom: 25px;
  width: 447px;
`;

export const AssetCountText = styled.b`
  color: ${({ theme }) => theme.headerColor};
`;

type ErrorTextProps = {
  fontWeight?: string;
  mb?: number;
};

export const ErrorText = styled.p<ErrorTextProps>`
  color: ${({ theme }) => theme.red};
  font-weight: ${({ fontWeight }) => fontWeight ?? 'normal'};
  margin-bottom: ${({ mb }) => mb ?? '25'}px;
  width: 447px;
`;

export const RequiredIndicator = styled.span`
  color: ${({ theme }) => theme.red};
  font-family: SimSun, sans-serif;
  font-size: 14px;
  font-weight: normal;
`;

export const FieldMappingRow = styled.div`
  align-items: flex-start;
  display: grid;
  gap: 16px;
  grid-template-columns: minmax(260px, 1fr) minmax(300px, 1fr);
  margin-bottom: 16px;
`;

export const FieldMappingLabel = styled(LabelText)`
  line-height: 32px;
`;

export const FieldMappingValue = styled(ValueText)`
  line-height: 32px;
`;
